export const USA_VALID_MIN_GRADE = 8
export const NORWAY_VALID_MIN_GRADE = 8
export const FLORIDA_VALID_MIN_GRADE = 8

/** Query params `/test/generate` reads to open with the grade and topic already selected. */
export enum TestGeneratorPrefillParam {
  COUNTRY = 'country',
  GRADE = 'grade',
  TOPIC = 'topic',
  /** Where the back button goes. Absent means the generator was reached from `/test/start`. */
  RETURN_TO = 'returnTo',
}

export const USA_COMING_SOON_MIN_GRADE = 5
export const NORWAY_COMING_SOON_MIN_GRADE = 5
export const FLORIDA_COMING_SOON_MIN_GRADE = 5

export const DifficultyLevelOptions = [
  { id: 'easy', label: 'Easy', key: 'easy', value: 'easy' },
  { id: 'medium', label: 'Medium', key: 'medium', value: 'medium' },
  { id: 'hard', label: 'Hard', key: 'hard', value: 'hard' },
]

export const ExerciseTypeOptions = [
  { id: 'mathProblems', label: 'Math Problems', key: 'mathProblems', value: 'mathProblems' },
  { id: 'wordProblems', label: 'Word Problems', key: 'wordProblems', value: 'wordProblems' },
]
